<template>
	<div class="form-options" @keyup.enter="doEnterThings()">
		<div v-if="bIsSaving" class="savingSpin"><div class="spinner"></div></div>
		<h6 class="text-danger" v-if="strFormErrors">Устраните ошибки в заполнении формы!</h6>

		<div v-if="masFormConfig.length>0 && ((typeof masFormConfig[0].bDraftOn != 'undefined' && isDraftOn(masFormConfig[0].bDraftOn)) || (typeof masFormConfig[0].bCanBeDraft != 'undefined' && masFormConfig[0].bCanBeDraft === true))">
			<label class="col-form-label mr-3"><span>Черновик</span></label>
			<base-switch
				v-model="bIgnoreRequired"
				type="primary"
				:on-text="'Да'"
				:off-text="'Нет'"
			></base-switch>
		</div>

		<collapse v-if="masFormConfig.length>0 && typeof masFormConfig[0].collapse != 'undefined' && masFormConfig[0].collapse === true" :activeIndex="0">
			<template v-for="(opt,index) in masFormConfig">
				<collapse-item :title="opt.blockTitle" v-if="typeof opt.collapse == 'undefined' && !opt.bHideTab" :name="'ci_'+index" :key="index" :ref="'collapse_'+index">
					<ReFormPrinterOptions
						@value-change="valueChange"
						v-bind="{opt}"
						:isCollapseItem="true"
						:frmAllConfig="masFormConfig"
						ref="fieldLists"
						@show-panel="collapse_activate(index)"
					/>
				</collapse-item>
			</template>
		</collapse>
		<tabs v-else-if="masFormConfig.length>0 && typeof masFormConfig[0].tabs != 'undefined' && masFormConfig[0].tabs === true" 	:activeTab="activeName"
			type="primary"
			tabContentClasses="tab-opt"
			centered
			inline
			simple
			class="card card-plain">
			<template v-for="(opt,index) in masFormConfig">
				<tab-pane v-if="typeof opt.tabs == 'undefined'" :id="'ci_'+index" :key="index" >
					<template v-slot:label><span class="tab-label">
						<i class="tab-icon" :class="opt.icon"></i><span>{{opt.blockTitle}}</span>
					</span></template>
					<ReFormPrinterOptions
						@value-change="valueChange"
						v-bind="{opt}"
						:isCollapseItem="true"
						:frmAllConfig="masFormConfig"
						ref="fieldLists"

						/>
				</tab-pane>
			</template>
		</tabs>
		<div v-else-if="masFormConfig.length>0 && typeof masFormConfig[0].checklist != 'undefined' && masFormConfig[0].checklist === true">
			<template v-for="(opt,index) in masFormConfig">
				<div class="check-list-row col-6 d-inline-block" v-if="typeof opt.elements != 'undefined'" :key="index">
					<ReFormPrinterOptions
						@value-change="valueChange"
						v-bind="{opt}"
						:frmAllConfig="masFormConfig"
						:isCheckList="true"
						ref="fieldLists"
					/>
				</div>
			</template>
		</div>
		<div class="list-row mx-0" v-else>
			<ReFormPrinterOptions
				@value-change="valueChange"
				v-for="(opt,index) in masFormConfig"
				:key="index"
				v-bind="{opt}"
				:frmAllConfig="masFormConfig"
				ref="fieldLists"
				/>
		</div>
		
		<div v-if="masFormConfig.length>0 && bInTaskEnd==false" class="bntGroup">
			<!-- <input @keyup.enter="doEnterThings()" > -->
			<!-- <base-button @click="doEnterThings()" ref="successButton" type="success" simple>SuccessBtnText</base-button> -->
			<base-button @click="SaveForm()"  type="success" simple>{{SuccessBtnText}}</base-button>
			<base-button v-if="typeof CancelGo === 'function'" @click="CancelGo()" type="danger" simple>{{CancelBtnText}}</base-button>
		</div>
	</div>
</template>

<script>
	import ReFormPrinterOptions from './ReFormPrinterOptions.vue';
	import { TabPane, Tabs, Collapse, CollapseItem, BaseSwitch } from 'src/components';
	import swal from 'sweetalert2';
	export default {
		name: 'ReFormPrinter',
		components: {
			ReFormPrinterOptions,
			TabPane,
			Tabs,
			Collapse, 
			CollapseItem,
			BaseSwitch
		},
		props: {
			masFormConfig: {
				type:Array,
				default: function(){return []}
			},
			objFormData: {
				type: Object,
				default: function(){return {}}
			},
			objSaveApiMethod:{
				type: Object,
				default: function(){return {}}
			},
			objSaveApiMethodDataParam: {
				type:String,
				default: '',
			},
			SuccessGo: Function,
			SuccessBtnText: {
				type:String,
				default: 'Сохранить',
			},
			CancelGo: Function,
			CancelBtnText: {
				type:String,
				default: 'Отменить',
			},
			bInTaskEnd: {
				type:Boolean,
				default: false,
			},
		},
		data () {
			return {
				ver: 1,
				bIsSaving: false,
				activeName: 'ci_1',
				valid: false,
				strFormErrors: '',
				params: {},
				external_params_map:{},
				callParentTimeoutFn:null,
				bIgnoreRequired:false,
				bDraftAutoSwitched: false,
			}
		},
		computed: {

		},
		mounted()  {

		},
		methods: {
			isDraftOn(draft_param=false){
				if (draft_param===true && this.bDraftAutoSwitched===false) {
					this.bIgnoreRequired = true;
					this.bDraftAutoSwitched=true;
				}
				return draft_param;
			},
			callParent(){
				clearTimeout(this.callParentTimeoutFn);
				this.callParentTimeoutFn = setTimeout(()=>this.$emit('value-change',this.params), 10);
			},
			collapse_activate(index){
				let c = this.$refs['collapse_'+index][0];
				// console.log(c);
				if(!c.active)
					c.activate();
			},
			errorField(name){
				if(this.$refs.fieldLists){
					for(let l of this.$refs.fieldLists){
						if(l.activateField(name)) break;
					}
				}
			},
			valueChange(event){
				// console.log('value change', event);
				if(event.element && event.element.elementGetParamMap){
					// console.log('set', this.params, event.element.elementGetParamMap, event.element.element_model);
					this.$set(this.params, event.element.elementGetParamMap, event.element.element_model);
					this.callParent();
					//this.$emit('value-change',this.params);
				}
				if(this.external_params_map[event.element.elementGetParamMap]){
					// передаём значения
					this.external_params_map[event.element.elementGetParamMap].forEach(element=>{
						// console.log('set',  event.element.elementGetParamMap, event.element.element_model);
						this.$set(element.external_params_value, event.element.elementGetParamMap, event.element.element_model)
					})
				}
				// console.log(event, this.params, this);
			},
			doEnterThings(e,dopParam) {
				
				// if (e.keyevent.keyname== 13) {
				// 	// this.SaveForm();
				// 	console.log("enter is pressed");
				// }
				//alert('Enter was pressed');

				// if((location.pathname.indexOf('/data/clients/add') != -1) || (location.href.includes('edit'))) {}
				if((location.pathname.indexOf('/data/clients/add') != -1) || (location.pathname.includes('clients') && location.pathname.includes('edit'))) {
					this.SaveForm();	
					//console.log("enter was pressed on client page or  edit page");	
				} else {
					//console.log("enter was pressed and this is not client page, yes!");	 
				}
					
			},
			GetComponentByFindId(findId){
				const tabs = this.$children[0].$children;
				//console.log(this.$children[0].$children[0].$children[0].$children);
				for (let ti = 0; ti < tabs.length; ti++) {
					for (let ci = 0; ci < this.$children[0].$children[ti].$children[0].$children.length; ci++) {
						//if(typeof this.$children[0].$children[ti].$children[0].$children[ci].findId != 'undefined'){
							if(this.$children[0].$children[ti].$children[0].$children[ci].findId == findId) return this.$children[0].$children[ti].$children[0].$children[ci];
						//}
					}
				}
				return false;
			},
			SaveForm(){
				this.bIsSaving=true;
				let objRet = {};
				for (let i = 0; i < this.masFormConfig.length; i++) {
					if(typeof this.masFormConfig[i].elements == 'undefined') continue;
					for (let iEl = 0; iEl < this.masFormConfig[i].elements.length; iEl++) {
						const el=this.masFormConfig[i].elements[iEl]
						if(typeof el.elementGetParamMap != 'undefined' && this.masFormConfig[0].checklist !== true){
							
							if(!this.bIgnoreRequired){
								if (!this.CheckRequired(el)) {
									this.bIsSaving=false;
									return false;
								}
							}
							// console.log(el.elementGetParamMap);
							// console.log(el.elementType);
							// console.log(el.element_model);
							if(!this.$GVO.isEmpty(el.element_model)){
								if(el.elementType == 'input-contact'){
									if(this.objSaveApiMethodDataParam != ''){
										if(typeof objRet[this.objSaveApiMethodDataParam] == 'undefined'){
											objRet[this.objSaveApiMethodDataParam] = [];
										}
									}else{
										if(typeof objRet[el.elementGetParamMap] == 'undefined'){
											objRet[el.elementGetParamMap] = [];
										}
									}
									for (let ind = 0; ind < el.element_model.length; ind++) {
										if(el.element_model[ind].contact_value != '' && el.element_model[ind].contact_type != ''){
											if(el.element_model[ind].contact_id == ''){
												el.element_model[ind].contact_id = 0;
											}
											if(el.element_model[ind].contact_view == ''){
												el.element_model[ind].contact_view = 0;
											}
											if(this.objSaveApiMethodDataParam != ''){
												objRet[this.objSaveApiMethodDataParam].push(el.element_model[ind]);
											}else{
												objRet[el.elementGetParamMap].push(el.element_model[ind]);
											}
										}
									}
								}else if(el.elementType == 'input-ajaxsearch-distrmetro'){
									objRet['district_ids'] = '';
									//objRet['direction_ids'] = [];
									objRet['metro_ids'] = '';
									//objRet['map_area'] = '';
									if(el.element_model.district_ids.value.length>0){
										objRet['district_ids'] = el.element_model.district_ids.value;
									}
									/*
									if(el.element_model.directions.all.length>0){
										objRet['direction_ids'] = el.element_model.directions.all;
									}
									*/
									if(el.element_model.metro_ids.value.length>0){
										objRet['metro_ids'] = el.element_model.metro_ids.value;
									}
									/*
									if(el.element_model.map.all.length>0){
										objRet['map_area'] = el.element_model.map.all;
									}
									*/
								}else if((el.elementGetParamMap == 'district_ids' || el.elementGetParamMap == 'direction_ids' || el.elementGetParamMap == 'metro_ids' || el.elementGetParamMap == 'map_area') && el.elementType=='hidden-input'){
									// не обрабатываем, тупо заглушка
								}else if(el.elementType == 'input-amount'){
									objRet[el.elementGetParamMap] = this.$GVO.str_replace(' ','',el.element_model);
								}else if(el.elementType == 'map-editor'){
									//заставить карту сохранить занчения в value
									let mapComponent = this.GetComponentByFindId(el.findId);
									//console.log(mapComponent);
									mapComponent.saveData();
									objRet[el.elementGetParamMap] = el.element_model;
								}else{
									objRet[el.elementGetParamMap] = el.element_model;
								}
							}else{
								if(el.elementGetParamMap == 'descr'){
									objRet[el.elementGetParamMap] = '';
								}else if(el.elementType == 'ajax-list-tags'){
									//console.log(el);
									objRet[el.elementGetParamMap] = [];
								}else if(el.elementType=='input-snils' || el.elementType=='input-basedatetime' || el.elementType=='input-inn'){
									objRet[el.elementGetParamMap] = '';
								}else if(el.elementGetParamMap == 'old_group'){
									objRet[el.elementGetParamMap] = [];
								}
							}
						}else if(typeof el.elementGetParamMap != 'undefined' && this.masFormConfig[0].checklist === true){
							if(typeof el.checklist != 'undefined'){
								if(typeof objRet[el.elementGetParamMap] == 'undefined'){
									objRet[el.elementGetParamMap] = [];
								}
								let ret = 0;
								if(el.checklist.element_model === true && el.required == true){ ret = 3;}
								else if(el.checklist.element_model === true){ ret = 1;}
								else if(el.checklist.element_model === false && el.required == true){ ret = 2;}
								objRet[el.elementGetParamMap]=ret;
							}
						}
					}
				}
				// console.log('данные для отправки формы',objRet);
				if(this.CheckValidate()){
					// console.log('this.CheckValidate()',this.CheckValidate());
					if(!this.$GVO.isEmpty(objRet)){
						let apiParam = this.objSaveApiMethod.apiParam;
						if(!this.$GVO.isEmpty(this.objSaveApiMethodDataParam)){
							apiParam[this.objSaveApiMethodDataParam] = objRet[this.objSaveApiMethodDataParam];
						}else{
							if(typeof apiParam['uData'] != 'undefined'){
								if(typeof apiParam['addData'] != 'undefined'){
									apiParam['uData'] = {...objRet,...apiParam['addData']};
								}else{
									apiParam['uData'] = objRet;
								}
							} else if(typeof apiParam['iData'] != 'undefined'){
								if(typeof apiParam['addData'] != 'undefined'){
									apiParam['iData'] = {...objRet,...apiParam['addData']};
								}else{
									apiParam['iData'] = objRet;
								}
							}
						}
						if(this.bIgnoreRequired===true)apiParam['flt']['bIgnoreRequired']=true;
						// console.log('данные для отправки формы в параметре',apiParam,this.objSaveApiMethod.apiMethod);
						//this.bIsSaving=false; return true;
						this.$GVO.ApiCall(this.objSaveApiMethod.apiMethod,apiParam)
							.then((objApi) => {  
								// console.log('Сохранение формы',apiParam,objApi);
								this.bIsSaving=false;
								if(objApi.success){
									// console.log('typeof this.SuccessGo',typeof this.SuccessGo);
									if (typeof this.SuccessGo != 'undefined') {
										this.SuccessGo(location.pathname, objApi);
									}
								}else{
									if(typeof objApi.ClientMsg == 'undefined')  {
										
										swal({
											title: 'Ошибка в данных',
											buttonsStyling: false,
											confirmButtonClass: 'btn btn-danger btn-fill',
											html: `Произошла ошибка проверки данных в полях:<br>
												${objApi.msg}`
										});
									}else if(objApi.ClientMsg) {
										// вся эта конструкция создана только затем, чтобы отображать ClientMsg, приходящий из Моих объектов (он теперь приходит в виде объекта)
										let adminMessage = '';
										if(this.$GVO.my_profile.adm == 1){
											adminMessage = objApi.msg;
										} 
										if(typeof objApi.ClientMsg === 'string') {
											// для ошибок отовсюду, кроме Моих объектов
											this.strFormErrors = objApi.ClientMsg.split(';');
											this.showSwalMObj('validate-error',this.strFormErrors);
											//console.log('this.strFormErrors typeof is string');
										} else {
											// для ошибок из Моих объектов
											this.strFormErrors = objApi.ClientMsg.msg.msg || objApi.ClientMsg.msg;
											//console.log('this.strFormErrors typeof is obj');
											if(objApi.ClientMsg.type == 'error_link'){
												swal({
													title: objApi.ClientMsg.title || 'Спасибо',
													buttonsStyling: false,
													confirmButtonClass: 'btn btn-danger btn-fill',
													html: `${this.strFormErrors} <br>
														<span class="text-danger">${adminMessage}</span>`
												}).then((result) => {
													// console.log('result',result,objApi.ClientMsg);
													if(result.value && objApi.ClientMsg.link) {
														location.href = (objApi.ClientMsg.link)
													}
												})
											}else{
												swal({
													title: 'Ошибка в данных',
													buttonsStyling: false,
													confirmButtonClass: 'btn btn-danger btn-fill',
													html: `Произошла ошибка проверки данных в полях:<br>
														${this.strFormErrors} <br>
														<span class="text-danger">${adminMessage}</span>`
												});
											}
										}
										
									}
									// Если пришли поля для заполнения.
									if(objApi&&objApi.ERR_DMP && objApi.ERR_DMP.update_model){
										this.update_model_values(objApi.ERR_DMP.update_model);
									}
								}
							})
							.catch((errorObjApi) => {console.error(errorObjApi); this.bIsSaving=false;});
					}else{
						this.bIsSaving=false;
						if (typeof this.SuccessGo != 'undefined') {
							this.SuccessGo(location.pathname);
						}
					}
				}else{
					this.bIsSaving=false;
				}
			},
			update_model_values(values){
				for (let i = 0; i < this.masFormConfig.length; i++) {
					const elements = this.masFormConfig[i].elements;
					for (const iEl in elements) {
						if (values.hasOwnProperty(elements[iEl].elementGetParamMap)) {
							// console.log(elements);
							this.$set(elements, iEl, {...elements[iEl], 'element_model': values[elements[iEl].elementGetParamMap]});
						}
					}
				}
				if(Object.prototype.hasOwnProperty.call(values,'draft')){
					this.bIgnoreRequired = values.draft;
				}
			},
			CheckRequired(el){
				// console.log('check req',el);
				// debugger;
				// console.log(el.elementGetParamMap, el.auto_hidden, el.auto_show, typeof el.auto_hidden, typeof el.auto_show, el.auto_hidden == true, !el.auto_show)
				//if (typeof el.auto_hidden != 'undefined' && typeof el.auto_show != 'undefined'){
					
					if (el.auto_hidden == true && !el.auto_show) return true; //костыль для АВТО скрытых полей
				// }
				if (el.elementType == 'input-hidden') { //костыль для скрытых инпутов
					return true;
				}
				if (el.elementType == 'checkbox') { //костыль на чекбоксы
					return true;
				}
				let f_label = '';
				if(typeof el.label != 'undefined' && el.label != '') {
					f_label = el.label;
				} else if(typeof el.placeholder != 'undefined' && el.placeholder != ''){
					f_label = el.placeholder;
				}
				if (el.required && (el.element_model == '' || this.$GVO.isEmpty(el.element_model))) {
					// console.log(el);
					this.showValidateError(f_label, el.elementGetParamMap);
					return false;
				}else if(el.elementType == 'input-contact'){
					if(el.required && el.element_model.length > 0){
						if(el.element_model[0].contact_value == '' && el.element_model[0].contact_group=='phone'){
							this.showValidateError(f_label, el.elementGetParamMap);
							//this.valid = true;
							return false;
						}
					}
				}else if(el.elementType == 'ajax-list'){
					if(el.required && (typeof el.element_model.selectedVal == 'undefined' || el.element_model.selectedVal == '')){
						this.showValidateError(f_label, el.elementGetParamMap);
						return false;
					}
				}else if(el.elementType == 'map-address'){
					if(el.required){
						if(typeof el.element_model.address.inputText == 'undefined' || el.element_model.address.inputText == ''){
							this.showValidateError(f_label, el.elementGetParamMap);
							return false;
						}
						if(el.element_model.address.regioncode==''){
							this.showSwal('validate-error',[{field:'Не указан регион'}]);
							return false;
						}
						if(Array.isArray(el.element_model.arrMetro)){
							let metro_err=[];
							el.element_model.arrMetro.forEach(metro=>{
								if(metro.metro_id>''){
									if(metro.distanceToMetro==''){
										if(metro.distanceType==''){
											metro_err.push(metro.metro_name+' не указан тип и время до метро')
										}else{
											metro_err.push(metro.metro_name+' не указано время до метро')
										}
									}else if(metro.distanceType==''){
										metro_err.push(metro.metro_name+' не указан способ добраться до метро (тип)')
									}
								}
							})
							if(metro_err.length>0){
								alert('Ошибка ввода данных о метро: '+metro_err.join('\n'));
								return false;
							}
						}
					}
				}else if(el.elementType == 'fio-padej' && el.required){
					if(el.element_model.name == ''){
						this.showValidateError('Имя клиента', el.elementGetParamMap);
						return false;
					}
					
				}else if(el.elementType == 'lead-call-cat' && el.required){
					if(el.element_model.selectedVal == ''){
						this.showValidateError('Ответственный за лид', el.elementGetParamMap);
						return false;
					}
					
				}
				return true;
			},
			CheckValidate(){
				// console.log("this.errors.items "+this.errors);
				if(this.errors.items.length > 0){
					
					this.showSwal('validate-error',this.errors.items);
					return false
				}
				return true;
			},
			LoadCats(){
				for (var b=0;b<this.masFormConfig.length;b++) {
					for (var e = 0; e < this.masFormConfig[b].elements.length; e++) {
						if (this.masFormConfig[b].elements[e].elementType == 'select' 
						) {
							//console.log(this.masFormConfig[b]);
							if(this.masFormConfig[b].elements[e].elementCat!=''){
								this.masFormConfig[b].elements[e].options = this.$GVO.getCatToSelect(this.masFormConfig[b].elements[e].elementCat);
							}
						} else if(this.masFormConfig[b].elements[e].elementType == 'input-contact' && this.masFormConfig[b].elements[e].elementCat == 'CONTACTS_TYPES'){
							this.masFormConfig[b].elements[e].contactGroup_options = [];
							//console.log(this.masFormConfig[b].elements[e].contactGroup);
							for (const key in this.$GVO.cats.CONTACTS_TYPES[this.masFormConfig[b].elements[e].contactGroup].types) {
								//console.log({value:key,label:this.$GVO.cats.CONTACTS_TYPES[this.masFormConfig[b].elements[e].contactGroup].types[key]});
								this.masFormConfig[b].elements[e].contactGroup_options.push({value:key,label:this.$GVO.cats.CONTACTS_TYPES[this.masFormConfig[b].elements[e].contactGroup].types[key]});
								if(this.masFormConfig[b].elements[e].contactGroup == 'email' || this.masFormConfig[b].elements[e].contactGroup == 'web'){
									this.masFormConfig[b].elements[e].element_model[0].contact_type = key; 
								}	
							}
						}
					}
				}
			},
			showValidateError(text, field){
				// debugger;
				// console.log(1223);
				return swal({
					title: 'Ошибка заполнения полей',
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-danger btn-fill',
					text: 'Необходимо заполнить обязательное поле: '+text,
				}).then(result=>{
					this.errorField(field);
					return result;
				})

			},
			showSwal(type,data=[]){
				// console.log(data);
				if (type === 'validate-error') {
					let masErFields = [];
					for (let i = 0; i < data.length; i++) {
						masErFields.push(data[i].field);
					}
					// console.log(masErFields);
					swal({
						title: 'Ошибка в данных',
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-danger btn-fill',
						html: `Произошла ошибка проверки данных в полях:<br>
							${masErFields.join(', ')}`
					});
				}
			},
			showSwalMObj(type,data=[]){
				// console.log(data);
				let masErFields = [];
				for (let i = 0; i < data.length; i++) {
						data[i] = '<li>' + data[i] + '</li>';
						masErFields.push(data[i]);
					}

				if (type === 'validate-error') {
					swal({
						title: 'Ошибка в данных',
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-danger btn-fill',
						html: `Произошла ошибка проверки данных в полях:<br>
							<ul class="list-unstyled result-marker" style="text-align:left;">
							${masErFields.join(' ')}
							</ul>`
								
					});
				}
			},
			// строим матрицу полей куда надо передать значения
			process_find_external_params(opt){
				if(opt.elements && opt.elements.forEach){
					opt.elements.forEach(element=>{
						// console.log(element.label, element);
						if(element.external_params){
							// console.log('define value', element)
							this.$set(element, 'external_params_value', {})
							element.external_params.forEach(param=>{
								if(!this.external_params_map[param]){
									this.external_params_map[param]=[];
								}
								this.external_params_map[param].push(element);
								this.$set(element.external_params_value, param, this.params[param])
								// element.external_params_value[param] = this.params[param];
							})
							
						}
					})
				}
			},
			create_external_params(){
				// console.log('create_external_params');
				this.external_params_map={};
				if(this.masFormConfig.length>0){
					this.masFormConfig.forEach(this.process_find_external_params)
				}
				// console.log(this.external_params_map);
			},
		},
		watch:{
			masFormConfig(){
				this.create_external_params();
			}
		},
		created(){
			this.$parent.$on('form_refresh',this.create_external_params);
			//this.LoadCats();
			if(location.hash != ''){
				this.activeName = this.$GVO.str_replace('#','',location.hash);
			};
			// console.log(this.masFormConfig);
			this.create_external_params();
		}
	}
</script>
<style>
	.savingSpin{
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0px;
		left: 0px;
		z-index: 1050;
		background-color: #000000b8;
	}
	.form-options .bntGroup{
		display: flex;
		justify-content: space-around;
	}
	.form-options .bntGroup > *{width: 125px;}

	.check-list-row > .form-options-group{width: 100% !important;}
	.check-list-row > .form-options-group > *{
		display: inline-flex;
	}
	.check-list-row > .form-options-group > .title{
		display: block;
	}
	.check-list-row > .form-options-group > .row {width: calc(100% - 40px);}

	.ReCardTaskEnd .card-collapse{width: 100% !important;}
	.ReCardTaskEnd #result {margin-top: 10px;}
	.swal2-popup .swal2-content {font-size: 1em!important;}

	@media (max-width: 850px){
		.form-options .tab-label > span{display: none;}
		.inoneline .tab-label .tab-icon{margin-right: 0px;}
	}
	@media (max-width: 525px){
		/*.ReCardClientEdit .inoneline {}*/ /* перенёс в src/assets/sass/dashboard/custom/_global.scss , т.к. тут не работает*/
		.inoneline .tab-label{
			height: 14px;
			margin-top: 5px;
		}
		.inoneline .tab-label .tab-icon{
			font-size: 14px;
    		line-height: 100%;
		}
	}
</style>
